import React from "react";
import "./ProfilDialog.css";
import type { User as BackendUser } from "../../types/user";
import { X, User, Mail, Shield, Building2 } from "lucide-react";

interface ProfilDialogProps {
  user: BackendUser;
  isOpen: boolean;
  onClose: () => void;
  sites?: Array<{ id: number; name: string }>;
}

const ProfilDialog: React.FC<ProfilDialogProps> = ({ user, isOpen, onClose, sites = [] }) => {
  if (!isOpen) return null;

  // Get user's site names
  const userSites = sites.filter((site) => user.sites.includes(site.id));

  return (
    <>
      <div className="profil-overlay" onClick={onClose} />
      <div className="profil-dialog">
        <div className="profil-header">
          <div className="profil-header-content">
            <div className="profil-avatar">
              <User size={32} strokeWidth={2} />
            </div>
            <div className="profil-header-text">
              <h2>Profil Utilisateur</h2>
              <p>Informations du compte</p>
            </div>
          </div>
          <button className="profil-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="profil-body">
          <div className="profil-section">
            <div className="profil-field">
              <div className="profil-field-icon">
                <User size={18} />
              </div>
              <div className="profil-field-content">
                <label>Nom d'utilisateur</label>
                <span>{user.username}</span>
              </div>
            </div>

            {user.first_name && (
              <div className="profil-field">
                <div className="profil-field-icon">
                  <User size={18} />
                </div>
                <div className="profil-field-content">
                  <label>Prénom</label>
                  <span>{user.first_name}</span>
                </div>
              </div>
            )}

            {user.last_name && (
              <div className="profil-field">
                <div className="profil-field-icon">
                  <User size={18} />
                </div>
                <div className="profil-field-content">
                  <label>Nom</label>
                  <span>{user.last_name}</span>
                </div>
              </div>
            )}

            {user.email && (
              <div className="profil-field">
                <div className="profil-field-icon">
                  <Mail size={18} />
                </div>
                <div className="profil-field-content">
                  <label>Email</label>
                  <span>{user.email}</span>
                </div>
              </div>
            )}

            <div className="profil-field">
              <div className="profil-field-icon">
                <Shield size={18} />
              </div>
              <div className="profil-field-content">
                <label>Rôle</label>
                <span className="profil-role-badge">{user.role}</span>
              </div>
            </div>

            <div className="profil-field">
              <div className="profil-field-icon">
                <Building2 size={18} />
              </div>
              <div className="profil-field-content">
                <label>Sites assignés</label>
                <div className="profil-sites-list">
                  {userSites.length > 0 ? (
                    userSites.map((site) => (
                      <span key={site.id} className="profil-site-badge">
                        {site.name}
                      </span>
                    ))
                  ) : (
                    <span className="profil-no-data">Aucun site assigné</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="profil-footer">
          <button className="profil-btn-close" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfilDialog;
